var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAgilizeSeusDocumentosAggerPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Captura_de_Tela_2022-04-19_a\\u0300s_09.51.58_Copy_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0DocumentosPopup{fill:#F7B500;}\r\n\t.st1DocumentosPopup{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st0DocumentosPopup",
    d: "M50,25c0,13.8-11.2,25-25,25S0,38.8,0,25S11.2,0,25,0S50,11.2,50,25"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st1DocumentosPopup",
    d: "M20,42.9L20,42.9c-0.3,0-0.7-0.1-0.9-0.3c-0.7-0.4-1.1-1.3-0.8-2.1l2.6-11.7l-7.3,1 c0,0-0.1,0-0.1,0c-1,0-1.9-0.8-1.9-1.9c0-0.4,0.2-0.9,0.5-1.2L27.3,7c0.3-0.4,0.9-0.7,1.4-0.7h0.1c1,0,1.8,0.9,1.8,1.9 c0,0.1,0,0.2,0,0.4l-2.7,11.8l7.4-1c0,0,0,0,0,0h0c0,0,0,0,0.1,0c1,0,1.9,0.8,1.9,1.9c0,0.5-0.2,0.9-0.5,1.2L21.4,42.3 c0,0,0,0,0,0.1C21,42.7,20.5,42.9,20,42.9z M21.8,27.1c0.4,0,0.8,0.3,0.8,0.8c0,0.1,0,0.1,0,0.2l-2.9,12.8c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1l15.3-19.7c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2 c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1l-8.4,1.1c0,0-0.1,0-0.1,0c-0.4,0-0.8-0.3-0.8-0.8c0-0.1,0-0.1,0-0.2l3-12.9 c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1L13.2,27.6c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.2 c0.1,0.1,0.1,0.1,0.2,0.1L21.8,27.1C21.7,27.1,21.8,27.1,21.8,27.1L21.8,27.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAgilizeSeusDocumentosAggerPopup);
export default __webpack_public_path__ + "static/media/icone-agilize-seus-documentos-agger-popup.8870bad201ba42d012b77754057be834.svg";
export { ForwardRef as ReactComponent };